import {
  Box, Card, CardContent, Grid, Typography,
} from '@material-ui/core';
import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

interface DestinationBinProps {
  destinationBin: string;
}
const DestinationBin: React.FC<DestinationBinProps> = ({ destinationBin }) => (
  <Card style={{ height: '100%' }}>
    <Grid container alignItems="stretch">
      <Grid item xs={12}>
        <Box p={2}>
          <Box pl={2}>
            <ArrowForwardIcon fontSize="large" />
            <Typography variant="h6">{'Place in Bin'}</Typography>
          </Box>
          <CardContent>
            <Typography variant="h4" noWrap color="primary">
              {`${destinationBin} `}
            </Typography>
            <Typography color="textSecondary">
              {'Next Destination'}
            </Typography>
          </CardContent>
        </Box>
      </Grid>
    </Grid>

  </Card>
);

export default DestinationBin;
